import { render, staticRenderFns } from "./AdminExchanges.vue?vue&type=template&id=5da64a11&scoped=true&"
import script from "./AdminExchanges.vue?vue&type=script&lang=js&"
export * from "./AdminExchanges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da64a11",
  null
  
)

export default component.exports